'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' });

var Crop = function Crop(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Crop = (0, _pure2.default)(Crop);
Crop.muiName = 'SvgIcon';

exports.default = Crop;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Crop.js
// module id = 2286
// module chunks = 0